import React from 'react';

import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

const Header: React.FC = () => {
    return (
        <Navbar bg="dark" variant="dark" expand="lg">
            <Container fluid>
                <Navbar.Brand href="/" title="Paris DB Converter">
                    Paris DB Converter
                </Navbar.Brand>
            </Container>
        </Navbar>
    );
};

export default Header;
